
import { gsap, Power1, Power4 , Power2, Power3} from "gsap";
import * as overlay from "./overlay.js";
$ = jQuery;

$("body").on("click active", "#responsive-nav-button:not(.open)", function (e) {
    e.preventDefault();
    $(this).addClass("open");
    openMenu();
});
$("body").on("click active", "#responsive-nav-button.open", function (e) {
    e.preventDefault();
    $(this).removeClass("open");
    closeMenu();
});

$("body").on("click", "#responsive-nav a", function (e) {
    closeMenu();
    overlay.closeOverlay();
});

export function closeMenu() {
    $("#page__content").removeClass("blur");
    $("#responsive-nav").removeClass("open");
    $("#responsive-nav-button").removeClass("open");
    $("#nav").removeClass("white");
    if ($(".overlay.hide").length == 1) {
        $(".logo").addClass("show");
    }
    $(".social-box").removeClass("white");
    $(".phone-box").removeClass("hide");
}

export function openMenu() {
    $("#page__content").addClass("blur");
    $("#responsive-nav").addClass("open");
    $(".logo").removeClass("show");
    $(".social-box").addClass("white");
    $(".phone-box").addClass("hide");
}